(function () {
  var STORAGE_KEY = 'maali-delivery';
  var root = document.documentElement;

  if (window.Shopify && window.Shopify.designMode) {
    root.classList.remove('maali-region-pending');
    root.removeAttribute('data-maali-city');
    return;
  }

  function readSaved() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || (saved.region !== 'karachi' && saved.region !== 'rest')) return null;
      return saved;
    } catch (error) {
      return null;
    }
  }

  function cityLabel(region) {
    return region === 'karachi' ? 'Karachi' : 'Other cities';
  }

  function saveCart(data) {
    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    var city = cityLabel(data.region);
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        note: 'Deliver to ' + city,
        attributes: {
          'Delivery city': city,
        },
      }),
    }).catch(function () {});
  }

  function shippingFields(data) {
    var fields = {
      'checkout[shipping_address][country]': 'Pakistan',
      'attributes[Delivery city]': cityLabel(data.region),
    };
    if (data.region === 'karachi') {
      fields['checkout[shipping_address][city]'] = 'Karachi';
      fields['checkout[shipping_address][province]'] = 'Sindh';
    }
    return fields;
  }

  function checkoutHref(href, data) {
    var url = new URL(href, window.location.origin);
    var fields = shippingFields(data);
    Object.keys(fields).forEach(function (key) {
      if (key.indexOf('checkout[') === 0) url.searchParams.set(key, fields[key]);
    });
    return url.pathname + url.search;
  }

  function ensureCheckoutFields(form, data) {
    var fields = shippingFields(data);
    Object.keys(fields).forEach(function (name) {
      var input = form.querySelector('input[data-maali-checkout="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('data-maali-checkout', name);
        input.name = name;
        form.appendChild(input);
      }
      input.value = fields[name];
    });
  }

  function wireCheckout(data) {
    document.querySelectorAll('a[href*="/checkout"]').forEach(function (link) {
      var raw = link.getAttribute('data-maali-checkout-href') || link.getAttribute('href');
      link.setAttribute('data-maali-checkout-href', raw.split('?')[0]);
      link.setAttribute('href', checkoutHref(raw.split('?')[0], data));
    });
    document.querySelectorAll('form').forEach(function (form) {
      if (form.querySelector('[name="checkout"]')) ensureCheckoutFields(form, data);
    });
  }

  function refreshLists(region) {
    document.querySelectorAll('[data-maali-region-list]').forEach(function (list) {
      var cards = list.querySelectorAll('[data-maali-region]');
      if (!cards.length) return;

      var visible = 0;
      cards.forEach(function (card) {
        var scope = (card.getAttribute('data-maali-region') || 'both').trim();
        var hideOutsideKarachi = region !== 'karachi' && scope === 'karachi';
        if (!hideOutsideKarachi) visible += 1;
        else {
          card.querySelectorAll('input').forEach(function (input) {
            input.checked = false;
          });
        }
      });

      var note = list.querySelector(':scope > .maali-region-empty');
      if (visible === 0) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'maali-region-empty';
          list.appendChild(note);
        }
        note.textContent = 'No plants in this list ship outside Karachi.';
      } else if (note) {
        note.remove();
      }

      var label = list.previousElementSibling;
      if (label && label.hasAttribute('data-maali-region-count')) {
        var noun = visible === 1 ? 'plant' : 'plants';
        var place = region === 'karachi' ? 'Karachi' : 'other cities';
        label.textContent = visible + ' ' + noun + ' for ' + place;
      }
    });
  }

  function paintDelivery(data) {
    document.querySelectorAll('[data-maali-fab-city]').forEach(function (el) {
      el.textContent = cityLabel(data.region);
    });
    wireCheckout(data);
  }

  function closeFab() {
    var fab = document.getElementById('maali-region-fab');
    var fabButton = document.querySelector('[data-maali-region-fab]');
    if (fab) fab.classList.remove('is-open');
    if (fabButton) fabButton.setAttribute('aria-expanded', 'false');
  }

  function openGate() {
    var form = document.getElementById('maali-region-form');
    if (!form) return;
    var saved = readSaved();
    if (saved) {
      var radio = form.querySelector('input[value="' + saved.region + '"]');
      if (radio) radio.checked = true;
    }
    root.classList.add('maali-region-open');
    closeFab();
    var focusTarget = form.querySelector('input[name="region"]:checked') || form.querySelector('input[name="region"]');
    if (focusTarget) focusTarget.focus();
  }

  function closeGate() {
    if (!readSaved()) return;
    root.classList.remove('maali-region-open');
  }

  function chooseRegion(region) {
    var data = { region: region };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      sessionStorage.removeItem('maali-delivery-synced');
    } catch (storageError) {}
    root.setAttribute('data-maali-city', data.region);
    root.classList.remove('maali-region-pending', 'maali-region-open');
    paintDelivery(data);
    refreshLists(data.region);
    document.dispatchEvent(new CustomEvent('maali:region'));
    saveCart(data);
    try {
      sessionStorage.setItem('maali-delivery-synced', '1');
    } catch (storageError) {}
  }

  var form = document.getElementById('maali-region-form');
  if (form) {
    form.addEventListener('click', function (event) {
      var choice = event.target.closest('.maali-region-choice');
      if (!choice) return;
      var regionInput = choice.querySelector('input[name="region"]');
      if (!regionInput) return;
      event.preventDefault();
      chooseRegion(regionInput.value);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-maali-region-fab]')) {
      var fab = document.getElementById('maali-region-fab');
      var fabButton = event.target.closest('[data-maali-region-fab]');
      if (fab) fab.classList.toggle('is-open');
      if (fabButton) fabButton.setAttribute('aria-expanded', fab && fab.classList.contains('is-open') ? 'true' : 'false');
      return;
    }
    if (!event.target.closest('#maali-region-fab')) closeFab();

    var checkoutTrigger = event.target.closest('a[href*="/checkout"], button[name="checkout"]');
    if (checkoutTrigger && checkoutTrigger.dataset.maaliReady !== '1') {
      var current = readSaved();
      if (current) {
        event.preventDefault();
        event.stopPropagation();
        saveCart(current).finally(function () {
          checkoutTrigger.dataset.maaliReady = '1';
          if (checkoutTrigger.tagName === 'A') {
            window.location.href = checkoutHref(checkoutTrigger.getAttribute('data-maali-checkout-href') || checkoutTrigger.getAttribute('href'), current);
          } else if (checkoutTrigger.form) {
            ensureCheckoutFields(checkoutTrigger.form, current);
            checkoutTrigger.form.submit();
          }
        });
        return;
      }
    }

    if (event.target.closest('[data-maali-region-change]')) {
      event.preventDefault();
      openGate();
      return;
    }
    if (event.target.closest('[data-maali-region-close]')) {
      closeGate();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeGate();
  });

  document.addEventListener(
    'submit',
    function (event) {
      var buy = event.target.closest('[data-maali-buy]');
      if (!buy) return;
      var city = root.getAttribute('data-maali-city');
      var scope = (buy.getAttribute('data-maali-region') || 'both').trim();
      if (!city || (city !== 'karachi' && scope === 'karachi')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  var saved = readSaved();
    if (saved) {
    paintDelivery(saved);
    refreshLists(saved.region);
    try {
      if (!sessionStorage.getItem('maali-delivery-synced')) {
        saveCart(saved);
        sessionStorage.setItem('maali-delivery-synced', '1');
      }
    } catch (storageError) {}
  } else if (form) {
    var firstChoice = form.querySelector('input[name="region"]');
    if (firstChoice) firstChoice.focus();
  }

  var main = document.getElementById('MainContent');
  if (main && window.MutationObserver) {
    var timer;
    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        var current = readSaved();
        if (current) refreshLists(current.region);
      }, 80);
    }).observe(main, { childList: true, subtree: true });
  }
})();
